import { useEffect, useCallback } from "react";
import { Grid, Typography, Box } from "@mui/material";
import axios from "axios";
import companyLogo from "../../../assets/images/nirantara_logo_new.svg";
import vajraPoweredByLogo from "../../../assets/images/vajra_powered_by_logo.svg";
import { getSubdomainLabel } from "../../../utils/consultantDomain";
import LoginSlider from "../../Login/LoginSlider";
import "../../SSO/sso.css";
import success from "../../../assets/Login/checkmark.svg";
import { api } from "../../../utils/api";
import { encryptDataFun } from "../../../utils/storage";
import { useUser } from "../../../context/AuthContext";

const Success = () => {
  const { setUser, setModule } = useUser();

  const fetchUserDetails = useCallback(async () => {
    const minimumLoaderDelay = new Promise((resolve) =>
      setTimeout(resolve, 3000),
    );

    try {
      const searchParams = new URLSearchParams(window.location.search);
      // SSO callback passes token as /sso-success?token=...
      const tokenFromUrl = searchParams.get("token");
      const bearerToken =
        tokenFromUrl ||
        searchParams.get("accessToken") ||
        sessionStorage.getItem("token");

      const verifyRequest = axios.post(
        `${api}/api/auth/verify/sso`,
        {},
        {
          withCredentials: true,
          headers: bearerToken
            ? { Authorization: `Bearer ${bearerToken}` }
            : {},
        },
      );

      const [response] = await Promise.all([verifyRequest, minimumLoaderDelay]);
      const res = response?.data || {};
      const resolvedToken = res?.token || bearerToken;

      if (resolvedToken) {
        sessionStorage.setItem("token", resolvedToken);
      }
      if (res?.refreshToken) {
        localStorage.setItem("refreshToken", res?.refreshToken);
      }
      if (res?.company) {
        localStorage.setItem("companyId", res?.company);
      }
      localStorage.setItem("user", encryptDataFun(res?.user || {}));
      localStorage.setItem(
        "questionareSubmitted",
        res?.user?.company?.questionareSubmitted,
      );
      localStorage.setItem("module", res?.user?.modules);
      setUser(res?.user || null);
      setModule(res?.user?.modules || []);

      if (res?.initialQuestionare || res?.user?.companyAdmin === false) {
        window.location.href = "/welcome";
      } else if (
        res?.initialQuestionare === false &&
        res?.user?.companyAdmin === true
      ) {
        window.location.href = "/company-information";
      }
    } catch (error) {
      console.error("SSO verify failed:", error);
    }
  }, [setModule, setUser]);

  useEffect(() => {
    fetchUserDetails();
  }, [fetchUserDetails]);

  return (
    <div className="sso-page-container">
      {/* Left Section - Image (remains same) */}
      <Grid item className="sso-left-panel">
        <LoginSlider />
      </Grid>

      {/* Right Section - Toggle between Login and OTP */}
      <Grid item className="sso-right-panel">
        <Box className="sso-right-content">
          <div className="sso-container">
            <img src={success} alt="Success" className="sso-success-image" />
            <p className="success-text">Sign-in successful!</p>
            <p className="success-text-secondary">
              Redirecting you to your Vajra dashboard...
            </p>
            <div className="sso-progress-bar">
              <div className="sso-progress-fill" />
            </div>
          </div>
          {/* Footer (remains same for both views) */}

          <Typography
            variant="body2"
            color="textSecondary"
            className="sso-footer"
          >
            Powered by
            <span className="sso-footer-logo-wrap">
              <img
                src={getSubdomainLabel() ? vajraPoweredByLogo : companyLogo}
                alt="Company Logo"
                className="sso-footer-logo"
              />
            </span>
          </Typography>
        </Box>
      </Grid>
    </div>
  );
};

export default Success;
